'use client';
import React, { Component } from 'react';
import './style.sass';

import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';

class Startups extends Component {
    render() {
        return (
            <ScrollAnimation
                className="startups"
                animateIn="fadeIn"
                offset={100}
                animateOnce={true}
                duration={1.5}
            >
                <div className="full-wrapper">
                    <CommonTitle>Стартапы</CommonTitle>
                    <div className="startups-bg">
                        <div className="startups-bg__title">О направлении:</div>
                        <div className="startups-bg__desc">
                            Для проекта в воронку нужны были проекты, которые на стадии более
                            осмысленного проекта и уже ищут инвестора. AdventureLand предлагает
                            им платформу, где могут с их проектом ознакомиться инвесторы, а также
                            стартапы могут прокачать свой питч или пройти акселератор.
                        </div>
                    </div>
                </div>

                <div className="starting starting--converse">
                    <div className="full-wrapper">
                        <div className="starting__grid">
                            <div className="starting__number">1</div>
                            <ScrollAnimation
                                animateIn="fadeIn"
                                offset={50}
                                animateOnce={true}
                                duration={1}
                                className="starting__item starting__item--img"
                            >
                                <div className="starting__img">
                                    <img
                                        src="/images/pic/adventureLand/starting/4.png"
                                        alt="Пример поста в ленте Фейсбука у целевой аудитории"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="starting__img-text">
                                    Пример поста в ленте Фейсбука у целевой аудитории
                                </div>
                            </ScrollAnimation>
                            <ScrollAnimation
                                animateIn="fadeIn"
                                offset={50}
                                animateOnce={true}
                                duration={1}
                                className="starting__item starting__item--text"
                            >
                                <div className="starting__content">
                                    <div className="starting__title">Первый запуск</div>
                                    <div className="starting__subtitle">
                                        Таргетированная реклама
                                    </div>
                                    <div className="starting__desc">
                                        <p>
                                            Первичная гипотеза была промотировать питч сессии
                                            стартапов перед инвесторами, в описании мероприятий
                                            приглашали новых стартапов принять участие,
                                            предварительно зарегистрировавшись в воронке.
                                        </p>
                                        <p>
                                            <b>KPI</b> — заявки на РОН
                                        </p>
                                        <p>
                                            <b>Канал</b> — таргетированная реклама в ФБ.
                                        </p>
                                    </div>
                                    <div className="starting__bot-text">
                                        Результат — охват более 50 000, приняли участие в просмотре
                                        питчей более 350 человек. Новых регистраций в воронке —
                                        33 стартапа.
                                    </div>
                                </div>
                            </ScrollAnimation>
                        </div>
                    </div>
                </div>

                <div className="starting">
                    <div className="full-wrapper">
                        <div className="starting__grid">
                            <div className="starting__number">2</div>
                            <div className="starting__end" />
                            <ScrollAnimation
                                animateIn="fadeIn"
                                offset={50}
                                animateOnce={true}
                                duration={1}
                                className="starting__item starting__item--img"
                            >
                                <div className="starting__img">
                                    <img
                                        src="/images/pic/adventureLand/starting/5.png"
                                        alt="Пример поста в ленте Фейсбука у целевой аудитории"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="starting__img-text">
                                    Пример поста в ленте Фейсбука у целевой аудитории
                                </div>
                            </ScrollAnimation>
                            <ScrollAnimation
                                animateIn="fadeIn"
                                offset={50}
                                animateOnce={true}
                                duration={1}
                                className="starting__item starting__item--text"
                            >
                                <div className="starting__content">
                                    <div className="starting__title">Второй запуск</div>
                                    <div className="starting__subtitle">
                                        Таргетированная реклама
                                    </div>
                                    <div className="starting__desc">
                                        <p>
                                            Следующим запустили гипотезу в виде приглашений
                                            на ИнвесТОР — мероприятие, где инвесторы выбирают
                                            проекты для инвестиций.
                                        </p>
                                        <p>
                                            Через участие в мероприятии планировалась работа с ними
                                            с целью регистрации в воронку стартапов.
                                        </p>
                                    </div>
                                    <div className="starting__bot-text">
                                        Механика была не удачной, стоимость лида была космической.
                                        <br /> Отказались в пользу другой гипотезы, смотрите
                                        в выводах.
                                    </div>
                                </div>
                            </ScrollAnimation>
                        </div>
                    </div>
                </div>

                <div className="results-bg">
                    <div className="full-wrapper">
                        <ScrollAnimation
                            animateIn="fadeIn"
                            offset={50}
                            animateOnce={true}
                            duration={1}
                            className="results-bg__bot"
                        >
                            <div className="results-bg__bot-title">Результаты в цифрах:</div>
                            <div className="results-bg__bot-grid">
                                <div className="results-bg__bot-item">
                                    <div className="results-bg__bot-big">Pitch Office Hours</div>
                                    <div className="results-bg__bot-text">
                                        Охват: <b>49 984 пользователя</b>
                                    </div>
                                    <div className="results-bg__bot-text">
                                        Показы: <b>181 267</b>
                                    </div>
                                </div>

                                <div className="results-bg__bot-item">
                                    <div className="results-bg__bot-big">ИнвесТОР</div>
                                    <div className="results-bg__bot-text">
                                        Охват: <b>8 906 пользователя</b>
                                    </div>
                                    <div className="results-bg__bot-text">
                                        Показы: <b>17 059</b>
                                    </div>
                                </div>
                            </div>
                        </ScrollAnimation>

                        <ScrollAnimation
                            animateIn="fadeIn"
                            offset={50}
                            animateOnce={true}
                            duration={1}
                            className="results-bg__bot"
                        >
                            <div className="results-bg__bot-title">
                                Основные выводы после стартовых гипотез:
                            </div>

                            <div className="results-bg__bot-desc">
                                Привлечение стартапов через внутренние мероприятия оказалось
                                не рабочей гипотезой. Самые эффективные запуски рекламных кампаний
                                были через коллаборационные мерпориятия со Starta Ventures и Pro
                                Invest, которые были бесплатными и онлайн в самом начале пандемии.
                                На специализированные мероприятия был большой ажиотаж и пришло много
                                релевантных лидов.
                            </div>
                            <div className="results-bg__bot-desc results-bg__bot-desc--bold">
                                Следующий ряд гипотез лежит в области подготовки новой посадочной
                                страницы возможностей стартапа в Сколково и работы с каналами
                                трафика на нее.
                            </div>
                        </ScrollAnimation>
                    </div>
                </div>
            </ScrollAnimation>
        );
    }
}

export default Startups;
